export default __webpack_public_path__ + "15f2789dd231f36d43a4839306b3a2cb.svg";